import { render, staticRenderFns } from "./ResumeEducationModal.vue?vue&type=template&id=4b55ce18&"
import script from "./ResumeEducationModal.vue?vue&type=script&lang=js&"
export * from "./ResumeEducationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports